<% var visit_type = visit_types.find(function(visit_type) { return visit_type.id == visit_type_id }) %>

<% if (visit_type) { %>
  <label class="field-label"><%= I18n.visit.labels.age_range %></label>
  <div class="radio-buttons">
    <label class="radio-button" role="button" tabindex="0">
      <input data-appointment-booking-wizard-behaviour="field-input" type="radio" name="in_age_range" value="true" <% if (in_age_range) { %>checked<% } %>>
      <div class="select-indicator"></div>
      <span class="radio-label">
        <% if (visit_type.minimum_age && visit_type.maximum_age) { %>
          <%= I18n.visit.age_range.between.replace('%{minimum}', visit_type.minimum_age).replace('%{maximum}', visit_type.maximum_age) %>
        <% } else if (visit_type.minimum_age) { %>
          <%= I18n.visit.age_range.or_older.replace('%{age}', visit_type.minimum_age) %>
        <% } else if (visit_type.maximum_age) { %>
          <%= I18n.visit.age_range.or_younger.replace('%{age}', visit_type.maximum_age) %>
        <% } %>
      </span>
    </label>
    <label class="radio-button" role="button" tabindex="0">
      <input data-appointment-booking-wizard-behaviour="field-input" type="radio" name="in_age_range" value="false" <% if (!in_age_range) { %>checked<% } %>>
      <div class="select-indicator"></div>
      <span class="radio-label">
        <% if (visit_type.minimum_age && visit_type.maximum_age) { %>
          <%= I18n.visit.age_range.outside.replace('%{minimum}', visit_type.minimum_age).replace('%{maximum}', visit_type.maximum_age) %>
        <% } else if (visit_type.minimum_age) { %>
          <%= I18n.visit.age_range.or_younger.replace('%{age}', visit_type.minimum_age - 1) %>
        <% } else if (visit_type.maximum_age) { %>
          <%= I18n.visit.age_range.or_older.replace('%{age}', visit_type.maximum_age + 1) %>
        <% } %>
      </span>
    </label>
  </div>
<% } %>
